const locale = {
	pageTitle: '联系我们 | 擎亿精密有限公司',
	pageDesc: '联系擎亿精密，取得走心机 CNC 精密加工报价。Cincom L20 瑞士型走心机，φ1–20mm 小径零件，公差 ±0.005mm，ISO 9001 认证。电话：0966-686-161。',
	pageKeywords: '擎亿精密联系, 走心机询价, Cincom L20 报价, 精密加工咨询, 瑞士型车床加工, CNC 加工联系, 新北市精密加工',
	title: '联系我们',
	subtitle: '请填写以下表单，我们将尽速与您联系',
	name: '公司名称 / 姓名',
	namePlaceholder: '擎亿精密',
	phone: '联系电话',
	phonePlaceholder: '02-8687-2058',
	email: '电子信箱',
	emailPlaceholder: 'example@company.com',
	content: '询问内容',
	contentPlaceholder: '请描述您的需求，例如：材质、数量、加工规格等…',
	file: '附件',
	selectFile: '选择档案',
	send: '送出询问',
	errorName: '请输入公司名称或姓名',
	errorContact: '请输入电话或电子信箱至少一项',
	errorEmail: '电子信箱格式不正确',
	mapTitle: '公司位置'
};

export default locale;
